export enum BankingCountry {
  CAN = 'CAN',
  US = 'US'
}
